export const WaterDropIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <g>
        <path d="M15.7158 9.90829L10 0.833344L4.28431 9.90828C3.68061 10.8276 3.33337 11.9044 3.33337 13.0556C3.33337 16.4306 6.31814 19.1667 10 19.1667C13.6819 19.1667 16.6667 16.4306 16.6667 13.0556C16.6667 11.9044 16.3195 10.8276 15.7158 9.90829Z" />
        <path d="M10 15.8333C11.8409 15.8333 13.3333 14.3409 13.3333 12.5" />
      </g>
    </svg>
  );
};
